import React, { useEffect, useState } from 'react'
import SocialMedia from '../../component/SocialMedia/socialMedia'
import { FaFolderOpen } from 'react-icons/fa' 
import Project from '../../models/Project'
import FeaturedProjectModal from '../../component/FeaturedProjectModal/FeaturedProjectModal'
import MiniProjectsModal from '../../component/MiniProjectsModal/MiniProjectsModal'
import featuredProjects from '../../data/featuredProjects'
import miniProjects from '../../data/miniProjects' 
// featured projects moved to src/data/featuredProjects.js
// import available as `featuredProjects` above
// Spy Chess Game, MDC Monitoring, Economy.com, Portfolio Website

// mini projects moved to src/data/miniProjects.js
// import available as `miniProjects` above
// AWS amplify app and flutter

function Projects() {
  const [scrollY, setScrollY] = useState(0)
  const [selectedProject, setSelectedProject] = useState(null)

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif", margin: 0, padding: 0 }}>
      {/* Hero */}
      <section style={{ height: '48vh', minHeight: 360, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', padding: '0 20px', opacity: scrollY < 80 ? 1 : 0.95, transition: 'opacity 0.6s ease' }}>
        <div>
          <FaFolderOpen style={{ fontSize: 48, marginBottom: 10 }} />
          <h1 style={{ fontSize: '40px', fontWeight: 700, margin: '6px 0 12px', transform: `translateY(${scrollY * 0.05}px)`, transition: 'transform 0.3s ease-out' }}>Featured Projects</h1>
          <p style={{ fontSize: '18px', maxWidth: 820, margin: '0 auto', lineHeight: 1.6 }}>A collection of projects illustrating my experience building modern web and mobile applications, combining advanced front-end development with scalable backend integrations to deliver fast, reliable user experiences.</p>
        </div>
      </section>

      {/* Projects Grid */}
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '80px 20px 60px 20px' }}>
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '28px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '16px' }}>Featured Projects</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '24px', marginTop: 16 }}>
            {featuredProjects.map((p) => (
              <article key={p.id} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') setSelectedProject(p) }} style={{ borderRadius: '14px', overflow: 'hidden', boxShadow: '0 6px 22px rgba(0,0,0,0.08)', background: '#fff', transition: 'transform 0.25s, box-shadow 0.25s', cursor: 'pointer' }} onClick={() => setSelectedProject(p)} onMouseEnter={e => (e.currentTarget.style.transform='translateY(-8px)')} onMouseLeave={e => (e.currentTarget.style.transform='translateY(0)')}>
                <div style={{ height: 220, display: 'flex', alignItems: 'center', justifyContent: 'center', background: p.imageUrl ? `url(${p.imageUrl}) center/cover no-repeat` : '#e9eefc' }}>
                  {!p.imageUrl && <div style={{ width: '90%', height: '75%', background: '#d0d9ff', borderRadius: 8 }} />}
                </div>
                <div style={{ padding: '22px' }}>
                  <h3 style={{ margin: '0 0 8px' }}>{p.title}</h3>
                  <p style={{ margin: 0, color: '#555' }}>{p.description}</p>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ fontSize: '28px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '16px' }}>Other Projects</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '18px', marginTop: 16 }}>
            {miniProjects.map((p) => (
              <article key={p.id} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') setSelectedProject(p) }} style={{ borderRadius: '10px', overflow: 'hidden', boxShadow: '0 4px 12px rgba(0,0,0,0.06)', background: '#fff', padding: '14px', transition: 'transform 0.2s', cursor: 'pointer' }} onClick={() => setSelectedProject(p)} onMouseEnter={e => (e.currentTarget.style.transform='translateY(-6px)')} onMouseLeave={e => (e.currentTarget.style.transform='translateY(0)')}>
                <div style={{ display: 'flex', gap: 10, alignItems: 'flex-start' }}>
                  <div style={{ width: 72, height: 48, background: p.imageUrl ? `url(${p.imageUrl}) center/cover no-repeat` : '#eef2ff', borderRadius: 6, flex: '0 0 auto' }} />
                  <div>
                    <h4 style={{ margin: '0 0 6px' }}>{p.title}</h4>
                    <p style={{ margin: 0, color: '#666', fontSize: 14 }}>{p.description}</p>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </section>

        <section style={{ marginTop: 40, textAlign: 'center' }}>
          <h2 style={{ fontSize: '26px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '18px' }}>More Projects</h2>
          <p style={{ color: '#555' }}>I have additional projects available on my GitHub — feel free to browse for implementation details and source code.</p>

          <SocialMedia size={44} />
        </section>
      </main>

      {/* Modal */}
      {selectedProject && (
        miniProjects.includes(selectedProject) ? (
          <MiniProjectsModal project={selectedProject} onClose={() => setSelectedProject(null)} />
        ) : (
          <FeaturedProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />
        )
      )}

    </div>
  )
}

export default Projects
